// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"mon-lIPcM7GL","impersonateLoader":"mon-FqnwIdFz","routeLoader":"mon-iosGRVC1","animatedSpinner":"mon-S5CXfP10"};